import cn from 'classnames';
import React, { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  type?: HeaderTypes;
}>;

type HeaderTypes = 1 | 2 | 3 | 4 | 5 | 6 | 7;
export const Header = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { type, children } = props;
  return (
    <div ref={ref} className={cn('header', { [`header-${type}`]: type })}>
      {children}
    </div>
  );
});

export const HeaderActions = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren<{}>
>((props, ref) => (
  <div ref={ref} className="header-actions">
    {props.children}
  </div>
));

export const HeaderBranding = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren<{}>
>((props, ref) => (
  <div ref={ref} className="branding">
    {props.children}
  </div>
));

export const HeaderNav = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren<{}>
>((props, ref) => (
  <div ref={ref} className="header-nav">
    {props.children}
  </div>
));
